var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Re-link-bank-accounts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.-Re-linked-Bank-Accounts",
    transform: "translate(-349.000000, -416.000000)",
    fill: "#26E3BA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-(1)",
    transform: "translate(349.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31049026,34.5499515 C6.15317869,34.7081875 5.93855084,34.7964731 5.71560288,34.7964731 C5.49265491,34.7964731 5.27802707,34.7081875 5.12071549,34.5499515 L0.369782373,29.798248 C-0.123260791,29.3052048 -0.123260791,28.5057045 0.369782373,28.0135859 L0.964669755,27.4185444 C1.45786702,26.9255012 2.25644284,26.9255012 2.74948601,27.4185444 L5.71560288,30.3848153 L13.7304817,22.3697824 C14.223679,21.8767392 15.0230252,21.8767392 15.515298,22.3697824 L16.1101854,22.9648239 C16.6032285,23.457867 16.6032285,24.2572132 16.1101854,24.749486 L6.31049026,34.5499515 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.a10ed96878d9b4c2debdc392d2bbabae.svg";
export { ForwardRef as ReactComponent };